<template>
  <PhDialog
    v-model="shown"
    @close="handleDialogClose"
    :heading="title"
    contentTextAlign="left"
    :fullscreen="true"
  >
    <template v-slot:content>
      <pre>
        <code v-html="sanitizedContent"></code>
      </pre>
    </template>
    <template v-slot:footer>
      <v-layout justify-end>
        <v-btn @click="copyContent" class="ml-4" text>Copy</v-btn>
        <v-btn @click="handleDialogClose" class="ml-4" text>Close</v-btn>
      </v-layout>
    </template>
  </PhDialog>
</template>

<script>
import { dialogWrapper } from '@/mixins';

const tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
};

export default {
  name: 'CodeDialog',
  mixins: [dialogWrapper],
  props: {
    title: {
      type: String,
      default: () => '',
    },
    content: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    copyContent() {
      navigator.clipboard.writeText(this.content);
    },
    replaceTag(tag) {
      return tagsToReplace[tag] || tag;
    },
    safeTagsReplace(str) {
      return str.replace(/[&<>]/g, this.replaceTag);
    },
  },
  computed: {
    sanitizedContent() {
      return this.safeTagsReplace(this.content);
    },
  },
};
</script>

<style lang="scss" scoped>
pre code {
  display: block;
}
</style>
